// (C) Copyright 2024 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Accordion, AccordionPanel, Grommet, Box } from 'grommet'
import PropTypes from 'prop-types'
import { deepMerge } from 'grommet/utils'
import { hpe } from 'grommet-theme-hpe'

import { Typography } from '../typography/Typography'

const panelTheme = deepMerge(hpe, {
  accordion: {
    panel: {
      border: {
        color: 'transparent'
      }
    },
    border: {
      color: 'dark-4'
    }
  },
  formField: {
    border: {
      color: 'transparent'
    }
  }
})

const renderPanelTitle = (icon, label, pad) => (
  <Box direction="row" testId="title-icon" align="center" gap="small" pad={pad}>
    {icon}
    <Typography type="heading" level="3" testId="accordion-title">
      {label}
    </Typography>
  </Box>
)

export const CCSAccordion = ({
  basis = 'large',
  icon = null,
  label = null,
  data,
  width = 'large',
  testId,
  customRender,
  ...rest
}) => {
  return (
    <Grommet theme={panelTheme}>
      <Accordion animate {...rest} basis={basis} width={width}>
        {data.map((datum) => {
          return (
            <AccordionPanel
              data-testid={`${datum.testid}-accordion-panel`}
              label={renderPanelTitle(icon(datum), label(datum), 'small')}
              key={datum}
            >
              {customRender(datum)}
            </AccordionPanel>
          )
        })}
      </Accordion>
    </Grommet>
  )
}

// Last Adding into the code
CCSAccordion.propTypes = {
  /**
   * It will be used for component reference to test.
   * This is mandatory.
   */
  testId: PropTypes.string.isRequired,
  /**
   * Content inside the AccordionPanels
   * This is mandatory.
   */
  width: PropTypes.node,
  /**
   * accordion title
   */
  label: PropTypes.func,
  /**
   * icon displayed to the left of element
   */
  icon: PropTypes.func,

  /**
   * Change AccordionPanels Size
   */
  basis: PropTypes.string,

  customRender: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired
}
